import { Component, OnInit } from '@angular/core';
import { GclidService } from '../../services/gclid.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(private gclidService: GclidService) {}

  ngOnInit(): void {
    this.gclidService.captureFromUrl();
  }
}

